import Modal from "../../../_components/Modal";
import React, { useEffect } from "react";
import Text from "../../../_components/Text";
import { createBarcodes } from "../../../api/barcodes";
import Button from "../../../_components/Button";
import AutoComplete from "../Financial/AutoComplete";
import { searchProducts, updateProduct, getProduct } from "../../../api/products";
import { _Input } from "../../../_components/Input"
import CheckBox from "../../../_components/Checkbox"
import Toast from "../../../_components/Toast";

// dados para configurar o Input costomizado do tipo select
const PROVIDER_BARCODES = [
    { label: "EAN13", value: "ean13" },
    { label: "EAN8", value: "ean8" },
    { label: "EAN14", value: "ean14" },
]

// componentes do Layout
import Page from "../../../_components/Layout/Page";
import Row from "../../../_components/Layout/Row";
import Column from "../../../_components/Layout/Column";
import { callSupport } from "../../../utils";

export default (props) => {

    const [loading, setLoading] = React.useState(false);
    const [ean, setEan] = React.useState("ean13")
    const [code, setCode] = React.useState("")
    const [description, setDescription] = React.useState("")
    const [needProduct, setNeedProduct] = React.useState(false)
    const [showWarning, setShowWarning] = React.useState(false)
    const [toast, setToast] = React.useState(false)
    const [toastMessage, setToastMessage] = React.useState('')
    useEffect(() => {
        if (toast) {
            const timer = setTimeout(() => {
                setToast(false);
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [toast]);

    async function onSave() {
        setShowWarning(false)
        if (loading) {
            return;
        }
        setLoading(true);

        if (props.barcodeList.some(obj => obj.product_id === code)) {
            setToast(true)
            setToastMessage("Esse produto já tem um código de barras!")
            setLoading(false)
            return;
        }

        if (description == "") {
            setToast(true)
            setToastMessage("A descrição não pode estar vazia!")
            setLoading(false)
            return;
        }

        try {
            const data = await createBarcodes(ean, description, code);

            if (needProduct && data.code) {
                try {
                    const product = await getProduct(code);

                    console.log(product)

                    await updateProduct({
                        id: code,
                        barcode: data.code,
                        unit: product.sellable.unit.id,  
                        price: product.sellable.price

                    });
                } catch (err) {
                    console.error("Erro ao atualizar o produto com o código de barras:", err);
                }
            }

            // ✅ lógica de finalização
            setTimeout(() => {
                if (props.onSave) {
                    props.onSave(data);
                }

                setCode("");
                setDescription("");
                setLoading(false);

                if (props.onHide) {
                    props.onHide();
                }
            }, 400);
        }
        catch (error) {
            setShowWarning(true)
            setLoading(false)
        }
    }



    function onChange(e) {
        // o componente retorna {name: '', value: ''}
        console.debug(e)
        setEan(e.value)
    }

    return (
        <Modal
            title="Criar código de barras"
            show={props.show}
            onHide={() => {
                if (props.onHide) {
                    props.onHide()
                }
            }}
        >
            <Page> {/* Já vem com um container padrão*/}
                <Row>{/* A row com algumas propriedades extras*/}
                    {/* A columns eu fiz pra receber propriedades responsivas*/}
                    {/* md é 4 pq é seria 12/3 ou seja = 3 */}
                    {/* Isso quer que em cada linha do coluna vai aparecer 3 elementos */}
                    {/* no caso do lg ele só mostra 2 */}
                    <Column xs="12" md="4" lg="6">
                        <Text color="primary">Tipo de código de barras</Text>
                        <_Input onChange={onChange} type="select" name="code_type" options={PROVIDER_BARCODES} />
                    </Column>
                    <Column xs="12" md="4" lg="6">
                        <Text color="primary">Descrição</Text>
                        <_Input disabled={loading} onChange={e => setDescription(e.value)} name="description" />
                    </Column>
                    {/* o hide tanto na linha quanto na coluna já serve pra mostrar ou esconder o elemento */}
                    {/* o page tbm tem hide */}
                    <Column xs="12" md="4" lg="6" hide={!needProduct}>
                        <Text color="primary">Produto associado</Text>
                        <Text>Informe o produto do código de barras</Text>
                        <AutoComplete
                            disabled={loading}
                            request={(...args) => searchProducts(...args).then(result => {
                                return result.map(item => ({
                                    ...item,
                                    'sellable.name': item.sellable.name
                                }));
                            })}
                            searchField='sellable.name'
                            labelField='sellable.name'
                            valueField='id'
                            onSelect={e => setCode(e.value)} />
                    </Column>
                    <Column xs="12" md="4" lg="6">
                        <CheckBox disabled={loading} onClick={value => setNeedProduct(!needProduct)} checked={needProduct} label="Associar produto ao código" />
                    </Column>
                    <Column col="12">
                        <div className="d-flex my-4 justify-content-center">
                            <Button disabled={loading} onClick={() => onSave()}>Criar código de barras</Button>
                        </div>
                    </Column>
                </Row>
                <Row className="d-flex justify-content-center align-items-center" hide={!showWarning}>
                    <Text color="danger">
                        Atenção! Você atingiu o limite gratuito de 100 códigos de barras.
                        Para mais códigos, realize a compra de qualquer plano Easygestor.</Text>
                    <Button onClick={() => window.location.href = "/plans/select"} as="text">
                        Quero mais códigos
                    </Button>
                </Row>
            </Page>

            <Toast
                message={toastMessage}
                show={toast}
            />
        </Modal>
    )
}


// WEBPACK FOOTER //
// ./src/views/AppViews/Barcodes/createBarcodeModal.jsx